/* ==========================================================================
  Ajax
	-----------------------------------------------
	- open class for elements = .js-ajax-open
	- target ajax item(s) = '#ajaxSource'
	- scroll on .ajax (overflow: hidden)
	- call loadIn on #ajaxContainer
	
	- 	jQuery(‘#ajaxContainer’).rhLoadIn({
       		ajax:true
		})
    
    - 	jQuery('.parallax').rhParallax({
			parallaxRatio:1.4,
			ajax:true,
			selector:'#ajaxContainer'
		});


  ========================================================================== */

var $ajaxContainer = jQuery("#ajaxContainer"),
    $closeAjaxButton = jQuery("#closeAjaxButton"),
    $ajaxDestination = jQuery("#ajaxDestination"),
    ajaxOpen = false,
    originalHref,
    ajaxHref,
    $ajaxLoader = jQuery("#ajaxLoader"),
    ScrollTrigger;

//ajax for cards
jQuery(document).on("click", ".js-ajax-open", function (e) {
    e.preventDefault();

    ajaxHref = jQuery(this).attr("href");

    if (ajaxOpen == false) {
        ajaxOpen = true;

        originalHref = window.location.href;

        $body.addClass("stop-scrolling");

        gsap.to($ajaxContainer, 0.4, {
            autoAlpha: 1,
            top: "0",
            ease: Power4.easeInOut,
            onComplete: openAjax,
            onCompleteParams: [ajaxHref]
        });

        gsap.to($closeAjaxButton, 0.3, {
            autoAlpha: 1,
            ease: Power4.easeInOut,
            delay: 0.5
        });
    }

    history.pushState({}, "", ajaxHref);
});

//history pop state
window.onpopstate = function () {
    $body.removeClass("stop-scrolling");

    if (ajaxOpen == true) {
        ajaxOpen = false;

        gsap.to($ajaxContainer, 0.4, {
            autoAlpha: 0,
            top: "100%",
            ease: Power4.easeInOut,
            onComplete: emptyAjax
        });

        gsap.to($closeAjaxButton, 0.4, { autoAlpha: 0 });

        history.pushState({}, "", originalHref);
    }
};

//close ajax
$closeAjaxButton.on("click", function (e) {
    e.preventDefault();

    ajaxOpen = false;

    $body.removeClass("stop-scrolling");

    gsap.to($ajaxContainer, 0.4, {
        autoAlpha: 0,
        top: "100%",
        ease: Power4.easeInOut,
        onComplete: emptyAjax
    });

    gsap.to($closeAjaxButton, 0.4, { autoAlpha: 0 });
    history.pushState({}, "", originalHref);
});

function openAjax(ajaxHref) {
    $ajaxDestination.load(ajaxHref + " #ajaxSource", function () {
        $ajaxLoader.fadeOut();

        //need ajax overlay as vanilla javascript element
        //load in
        //get else
        const ajaxOverlay = document.querySelector(".js-ajax-overlay"),
            loadinEls = ajaxOverlay.querySelectorAll(".load-in"),
            //set options
            duration = 0.8,
            fromDistance = 0,
            easing = Power4.easeInOut;

            ScrollTrigger.batch(loadinEls, {
                scroller: ".js-ajax-overlay",
                onEnter: (batch) =>
                    gsap.fromTo(
                        batch,
                        {
                            y: fromDistance,
                            autoAlpha: 0
                        },
                        {
                            duration: duration,
                            autoAlpha: 1,
                            y: 0,
                            stagger: 0.05,
                            overwrite: true,
                            ease: easing
                        }
                    )
            });

        // $ajaxDestination.imagesLoaded(function () {});
    });
}

function emptyAjax() {
    // ScrollTrigger.getById("load-in-ajax").kill();
    $ajaxDestination.empty();
    $ajaxLoader.show();
}
